import { CardAction } from '../constants/BehaviorTypes';
import ContractCardAction from '../behaviors/contract/ContractCardAction';
export const Contract = {
  [CardAction]: () => ContractCardAction
};